import React from 'react';
import { TypedMemo } from '../../common/types';
import { LoadingView } from '../../common/views/LoadingView';
import { useAccountId } from '../../../redux/slices/appInfo/hooks';
import { FansScreen } from './FansScreen';

/** The Fans route `/fans` (design presave-subscriptions c1). Every call is account-scoped. */
const FansViewComponent: React.FC = () => {
  const accountId = useAccountId();

  if (accountId === null) {
    return <LoadingView />;
  }

  return <FansScreen accountId={accountId} />;
};

export const FansView = TypedMemo(FansViewComponent);
